import { createSlice } from "@reduxjs/toolkit";
import {
  getTeamMembers,
  patchTeamMember,
  postTeamMember,
  deleteTeamMember,
} from "./teamMembersAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  teamUsers: {},
};

const teamMembersSlice = createSlice({
  name: "teamMembers",
  initialState,
  reducers: {
    resetTeamMemberError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
    resetTeamMemberSuccess: (state) => {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTeamMembers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTeamMembers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.teamUsers = payload;
        state.error = null;
      })
      .addCase(getTeamMembers.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(patchTeamMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(patchTeamMember.fulfilled, (state, { payload }) => {
        state.loading = false;
        const updatedTeamUsers = state?.teamUsers?.results?.map((el) =>
          el?.id === payload?.id ? payload : el
        );
        state.teamUsers = {
          meta: state.teamUsers?.meta,
          results: updatedTeamUsers,
        };
        state.error = null;
        state.success = true;
      })
      .addCase(patchTeamMember.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(postTeamMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postTeamMember.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.teamUsers = {
          meta: state?.teamUsers?.meta,
          results: [payload, ...state?.teamUsers?.results],
        };
        state.error = null;
        state.success = true;
      })
      .addCase(postTeamMember.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(deleteTeamMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTeamMember.fulfilled, (state, { payload }) => {
        state.loading = false;
        const results = state?.teamUsers?.results?.filter(
          (el) => el?.id !== payload?.id
        );
        const count = state?.teamUsers?.meta?.count;
        state.teamUsers = {
          meta: {
            ...state?.teamUsers?.meta,
            count:
              typeof count === "number" ? Math.max(count - 1, 0) : count,
          },
          results: results ?? [],
        };
        state.error = null;
      })
      .addCase(deleteTeamMember.rejected, (state) => {
        // Delete errors are surfaced by the caller (useUserType1.removeTeamMember),
        // so we don't write them to state.error to avoid a duplicate toast.
        state.loading = false;
      });
  },
});
export const { resetTeamMemberError, resetTeamMemberSuccess } =
  teamMembersSlice.actions;
export default teamMembersSlice.reducer;
